import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { AdditionalRecordDetails, MiningShovel_LU_COMPART_TYPE } from '../report-builder-models';

@Component({
    selector: 'additional-record',
    templateUrl: './additional-record.component.html',
    styleUrls: ['./additional-record.component.scss']
})
export class AdditionalRecordComponent implements OnInit // ,OnChanges
{
    // ngOnChanges(changes: SimpleChanges): void {
    //     if(this.ARDetails){
    //         console.log(this.ARDetails)
    //         console.log(changes);
    //     }
    // }

    @Input() ARDetails: AdditionalRecordDetails[] = [];
    @Input() UoM = '';
    @Input() CompartType = 0;
    @Input() isHidden = false;
    @Input() hideToggle = false;

    @Output() toggleData: EventEmitter<number> = new EventEmitter();

    displayToggleButton = false;
    isTrackRoller = false;

    constructor() { }

    ngOnInit() {
        console.log("ARDetails", this.ARDetails)
        // Check for the Track Roller exception.
        // TT 839  all components should have addtional records

        // if (this.CompartType == MiningShovel_LU_COMPART_TYPE.TrackRoller) {
        //     this.isTrackRoller = true;
        //     console.log("ARDetails", this.isTrackRoller,this.ARDetails)
        // }

        
    }

    // Yes = 1, No = 0
    parseYesNo(val) {
        if (val === "1.00") {
            return 'Yes';
        } else {
            return 'No';
        }
    }

    toggleShowOrHide() {
        this.isHidden = !(this.isHidden);
        this.toggleData.emit(this.CompartType);
    }

    onMouseOver() {
        if (!this.hideToggle) {
            this.displayToggleButton = true;
        }
    }

    onMouseOut() {
        if (!this.hideToggle) {
            this.displayToggleButton = false;
        }
    }
}
